/* ==========================================================================
   Backup sizing calculator
   --------------------------------------------------------------------------
   Malaysian 240 V loads with startup surge and duty cycles. Units and prices
   come from the section's JSON island, which Liquid fills from live products.
   ========================================================================== */

(function () {
  'use strict';

  var EFF = 0.88;    /* inverter + conversion losses */
  var USABLE = 0.95; /* LFP usable fraction of nameplate (BMS reserve) */
  var SUN = 4.5;     /* peak-sun hours/day, KL — Global Solar Atlas */
  var PORT = 0.62;   /* portable folding panel yield vs STC */
  var WET = 0.25;    /* heavy monsoon-rain day, fraction of clear-sky */

  /* run = continuous W, surge = startup W, duty = fraction of time drawing. */
  var AP = [
    { id:'fan',      g:'Cooling',   n:'Ceiling fan',            run:75,   surge:90,   duty:1.00 },
    { id:'sfan',     g:'Cooling',   n:'Standing fan',           run:55,   surge:75,   duty:1.00 },
    { id:'ac10i',    g:'Cooling',   n:'Aircon 1.0 HP inverter', run:750,  surge:900,  duty:0.65 },
    { id:'ac15i',    g:'Cooling',   n:'Aircon 1.5 HP inverter', run:1100, surge:1350, duty:0.65 },
    { id:'ac20i',    g:'Cooling',   n:'Aircon 2.0 HP inverter', run:1500, surge:1800, duty:0.65 },
    { id:'ac10n',    g:'Cooling',   n:'Aircon 1.0 HP non-inv',  run:900,  surge:2700, duty:0.75 },
    { id:'ac15n',    g:'Cooling',   n:'Aircon 1.5 HP non-inv',  run:1300, surge:3900, duty:0.75 },

    { id:'fridge',   g:'Kitchen',   n:'Fridge (2-door)',        run:150,  surge:900,  duty:0.35 },
    { id:'freezer',  g:'Kitchen',   n:'Chest freezer',          run:120,  surge:800,  duty:0.40 },
    { id:'rice',     g:'Kitchen',   n:'Rice cooker',            run:700,  surge:700,  duty:0.45 },
    { id:'kettle',   g:'Kitchen',   n:'Electric kettle',        run:1800, surge:1800, duty:0.06 },
    { id:'micro',    g:'Kitchen',   n:'Microwave',              run:1200, surge:1700, duty:0.10 },
    { id:'induction',g:'Kitchen',   n:'Induction cooker',       run:2000, surge:2000, duty:0.25 },
    { id:'fryer',    g:'Kitchen',   n:'Air fryer',              run:1500, surge:1500, duty:0.20 },

    { id:'lights',   g:'Household', n:'LED lights ×6',     run:60,   surge:60,   duty:1.00 },
    { id:'wifi',     g:'Household', n:'WiFi router + ONU',      run:20,   surge:20,   duty:1.00 },
    { id:'tv',       g:'Household', n:'TV 55"',                 run:120,  surge:150,  duty:1.00 },
    { id:'laptop',   g:'Household', n:'Laptop',                 run:65,   surge:65,   duty:1.00 },
    { id:'phone',    g:'Household', n:'Phones ×2',         run:30,   surge:30,   duty:0.50 },
    { id:'pump',     g:'Household', n:'Water pump',             run:400,  surge:1200, duty:0.30 },
    { id:'washer',   g:'Household', n:'Washing machine',        run:500,  surge:1500, duty:0.50 },
    { id:'cpap',     g:'Household', n:'CPAP machine',           run:40,   surge:50,   duty:1.00 },
    { id:'heater',   g:'Household', n:'Instant water heater',   run:3600, surge:3600, duty:0.15, risky:true },

    { id:'pos',      g:'Business',  n:'POS + receipt printer',  run:150,  surge:200,  duty:1.00 },
    { id:'cfreezer', g:'Business',  n:'Commercial freezer',     run:300,  surge:1500, duty:0.45 },
    { id:'coffee',   g:'Business',  n:'Coffee machine',         run:1400, surge:1800, duty:0.30 },
    { id:'shutter',  g:'Business',  n:'Roller shutter motor',   run:550,  surge:1650, duty:0.02 }
  ];

  var GROUPS = ['Cooling', 'Kitchen', 'Household', 'Business'];

  var SCEN = {
    blackout: { h:4,  b:{ lights:1, wifi:1, fridge:1, fan:2, phone:1 } },
    monsoon:  { h:12, b:{ lights:1, wifi:1, fridge:1, fan:2, phone:1 } },
    wfh:      { h:4,  b:{ wifi:1, laptop:1, lights:1, fan:1 } },
    outdoor:  { h:8,  b:{ lights:1, phone:1, freezer:1, fan:1 } },
    shop:     { h:6,  b:{ pos:1, lights:1, wifi:1, cfreezer:1, fan:1 } }
  };

  var PANELS = [
    { n:'110 W portable', w:110 }, { n:'160 W portable', w:160 },
    { n:'220 W bifacial', w:220 }, { n:'400 W portable', w:400 }
  ];

  /* The result panel carries its own layout class from the section markup
     (ef-calc__sticky: the padding and the sticky offset). Assigning className
     wholesale wiped it on the first render, so the figures ended up flush
     against the panel edge and the panel stopped sticking. Toggle only the
     reveal classes and leave whatever the markup brought with it. */
  function reveal(el, on) {
    el.classList.toggle('ef-reveal', on);
    el.classList.toggle('is-in', on);
  }

  function money(n) { return 'RM ' + Math.round(n).toLocaleString('en-MY'); }
  function num(n)   { return Math.round(n).toLocaleString('en-MY'); }
  function byId(id) { for (var i = 0; i < AP.length; i++) if (AP[i].id === id) return AP[i]; return null; }
  function shortName(n) { return n.replace(/\s*\(.*$/, '').toLowerCase(); }

  function build(root) {
    if (root.dataset.efCalcBound) return;
    root.dataset.efCalcBound = '1';

    var unitsNode = root.querySelector('[data-ef-units]');
    var cfgNode   = root.querySelector('[data-ef-config]');
    var UNITS = [], CFG = { ceiling: 20000, cartText: 'Add to cart' };
    try { UNITS = JSON.parse(unitsNode.textContent) || []; } catch (e) {}
    try { CFG = Object.assign(CFG, JSON.parse(cfgNode.textContent)); } catch (e) {}

    UNITS = UNITS.filter(function (u) { return u.wh > 0 && u.ac > 0; })
                 .sort(function (a, b) { return a.rm - b.rm; });

    var sel = {}, hours = 4;
    var groupsEl = root.querySelector('[data-ef-groups]');
    var hrsEl    = root.querySelector('[data-ef-hrs]');
    var hrsVal   = root.querySelector('[data-ef-hrs-val]');
    var out      = root.querySelector('[data-ef-result]');

    /* ---- chips ---- */
    GROUPS.forEach(function (g) {
      var wrap = document.createElement('div');
      wrap.className = 'ef-calc__grp';
      var h = document.createElement('div');
      h.className = 'ef-calc__grp-h';
      h.textContent = g;
      wrap.appendChild(h);
      var chips = document.createElement('div');
      chips.className = 'ef-calc__chips';
      AP.filter(function (a) { return a.g === g; }).forEach(function (a) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ef-chip' + (a.risky ? ' is-risky' : '');
        b.setAttribute('aria-pressed', 'false');
        b.dataset.id = a.id;
        b.innerHTML = '<span class="nm"></span><span class="w">' + num(a.run) + ' W</span>';
        b.querySelector('.nm').textContent = a.n;
        b.addEventListener('click', function (e) {
          if (e.target.closest('.ef-qty')) return;
          if (sel[a.id]) delete sel[a.id]; else sel[a.id] = 1;
          render();
        });
        chips.appendChild(b);
      });
      wrap.appendChild(chips);
      groupsEl.appendChild(wrap);
    });

    /* ---- engine ---- */
    function compute() {
      var cont = 0, energy = 0, best = 0, worst = null, count = 0, effCont = 0;
      Object.keys(sel).forEach(function (id) {
        var a = byId(id), q = sel[id];
        if (!a) return;
        count += q;
        cont += a.run * q;
        energy += a.run * q * hours * a.duty;
        effCont += a.run * q * a.duty;
        var d = a.surge - a.run;
        if (d > best) { best = d; worst = a; }
      });
      return { cont: cont, effCont: effCont, surge: cont + best, surgeItem: worst,
               draw: energy / EFF, count: count };
    }

    function powerOk(u, c) { return u.ac >= c.cont && u.surge >= c.surge; }

    function batsFor(u, c) {
      if (u.wh * USABLE >= c.draw) return 0;
      if (!u.xb || !u.xb.wh) return -1;
      var n = Math.ceil((c.draw - u.wh * USABLE) / (u.xb.wh * USABLE));
      return n <= u.xb.max ? n : -1;
    }

    /* Cheapest valid configuration. Monotonic by construction: as the load
       grows the valid set only shrinks, so the minimum total can only rise.
       Any rule preferring a pricier config on another axis makes the slider
       move backwards, which reads as a bug. */
    function choose(c) {
      var best = null;
      for (var i = 0; i < UNITS.length; i++) {
        var u = UNITS[i];
        if (!u.avail || !powerOk(u, c)) continue;
        var n = batsFor(u, c);
        if (n < 0) continue;
        var total = u.rm + (n ? n * u.xb.rm : 0);
        if (!best || total < best.total || (total === best.total && n < best.bats)) {
          best = { u: u, idx: i, bats: n, total: total };
        }
      }
      return best && best.total <= CFG.ceiling ? best : null;
    }

    function row(k, v) {
      return '<div class="ef-res__check"><i>&#10003;</i><span class="k">' + k +
             '</span><span class="v">' + v + '</span></div>';
    }

    /* ---- render ---- */
    function render() {
      root.querySelectorAll('.ef-chip').forEach(function (b) {
        var id = b.dataset.id, on = !!sel[id];
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var q = b.querySelector('.ef-qty');
        if (on && !q) {
          q = document.createElement('span');
          q.className = 'ef-qty';
          q.innerHTML = '<button type="button" aria-label="Fewer">&minus;</button><span></span><button type="button" aria-label="More">+</button>';
          q.children[0].addEventListener('click', function (ev) {
            ev.stopPropagation();
            if (sel[id] > 1) sel[id]--; else delete sel[id];
            render();
          });
          q.children[2].addEventListener('click', function (ev) {
            ev.stopPropagation();
            if (sel[id] < 9) sel[id]++;
            render();
          });
          b.appendChild(q);
        } else if (!on && q) { q.remove(); }
        if (on) b.querySelector('.ef-qty span').textContent = '×' + sel[id];
      });

      var c = compute();

      if (!c.count) {
        reveal(out, false);
        out.innerHTML = '<div class="ef-res__lab">Recommendation</div>' +
          '<p class="ef-t-small ef-ink-3">Pick a scenario above, or tap the appliances you need to keep running. The recommendation updates as you go.</p>';
        return;
      }

      if (!UNITS.length) {
        out.innerHTML = '<div class="ef-res__lab">Recommendation</div>' +
          '<p class="ef-t-small ef-ink-3">No power stations configured yet. Add them as blocks in the theme editor.</p>';
        return;
      }

      var cfg = choose(c);
      var h = '<div class="ef-res__lab">Recommendation</div>';

      if (!cfg) {
        var top = UNITS[UNITS.length - 1];
        var why = [];
        if (top.ac < c.cont) why.push('a continuous draw of ' + num(c.cont) + ' W is past its ' + num(top.ac) + ' W inverter');
        if (top.surge < c.surge) why.push('a startup peak of ' + num(c.surge) + ' W is past its ' + num(top.surge) + ' W surge rating');
        if (!why.length) why.push('you need ' + num(c.draw) + ' Wh, more than it reaches even fully expanded');
        h += '<div class="ef-res__name">No single system does this</div>' +
             '<p class="ef-res__run">' + why.join(', and ') + '.</p>' +
             '<div class="ef-res__note is-crit">This is a consultative sale, not a catalogue purchase. Talk to us and we will size it properly.</div>' +
             '<div class="ef-res__alt">Dropping the heaviest item, or shortening the runtime target, usually brings this back inside the range.</div>';
        reveal(out, true);
        out.innerHTML = h;
        return;
      }

      var pick = cfg.u, bats = cfg.bats;
      var totalWh = pick.wh + bats * (pick.xb ? pick.xb.wh : 0);
      var usable = totalWh * USABLE;
      var runtime = c.effCont > 0 ? usable * EFF / c.effCont : 0;
      var runTxt = runtime >= 48 ? Math.floor(runtime / 24) + ' days'
                 : runtime >= 1  ? Math.floor(runtime) + ' h ' + Math.round((runtime % 1) * 60) + ' min'
                 : Math.round(runtime * 60) + ' min';

      h += '<div class="ef-res__name">' + pick.n +
           (bats ? '<span class="ef-res__sub">+ ' + bats + ' × ' + pick.xb.n + '</span>' : '') + '</div>' +
           '<div><span class="ef-price" style="font-size:26px">' + money(cfg.total) + '</span></div>' +
           '<p class="ef-res__run">Runs your selection for about <b>' + runTxt + '</b> &middot; ' + pick.ups + ' ms switchover</p>';

      h += '<div class="ef-res__checks">' +
           row('Continuous load', num(c.cont) + ' / ' + num(pick.ac) + ' W') +
           row('Startup peak' + (c.surgeItem ? ' — ' + shortName(c.surgeItem.n) : ''), num(c.surge) + ' / ' + num(pick.surge) + ' W') +
           row('Energy over ' + hours + ' h', num(c.draw) + ' / ' + num(usable) + ' Wh') +
           '</div>';

      if (bats) {
        h += '<div class="ef-res__note is-good">The ' + pick.n + ' alone has the <b>power</b> for this load — it is the <b>runtime</b> that needs the extra ' +
             (bats > 1 ? 'batteries' : 'battery') + '. Shorten the hours target and you drop back to the base unit.</div>';
      }
      if (sel.heater) {
        h += '<div class="ef-res__note is-crit">An instant water heater at 3,600 W is the heaviest thing in a Malaysian home. It works here on paper, but in practice we would tell you to skip it during an outage and save the capacity for the fridge.</div>';
      }
      if (sel.ac15n || sel.ac10n) {
        h += '<div class="ef-res__note is-warn">Non-inverter aircon draws roughly <b>3× its rated load</b> at startup. That surge, not the running watts, is what decides the unit.</div>';
      }

      /* solar */
      var panel = PANELS.filter(function (p) { return p.w <= pick.sol; }).pop() || PANELS[0];
      var perDay = panel.w * PORT * SUN;
      var days = totalWh / perDay;
      h += '<div class="ef-res__add">' +
           '<div class="ef-res__row"><span>' + panel.n + ' solar</span><b>' + (perDay / 1000).toFixed(1) + ' kWh/day</b></div>' +
           '<div class="ef-res__row"><span>Full recharge, clear KL sky</span><b>' +
             (days < 1 ? Math.round(days * SUN * 10) / 10 + ' h' : days.toFixed(1) + ' days') + '</b></div>' +
           (pick.care ? '<div class="ef-res__row"><span>' + pick.care.n + '</span><b>' + money(pick.care.rm) + '</b></div>' : '') +
           '</div>';

      if (sel.pump || hours >= 10) {
        h += '<div class="ef-res__note is-warn">On a heavy monsoon-rain day this panel makes roughly <b>' + num(perDay * WET) +
             ' Wh</b> — about a quarter of the figure above. Solar is weakest during exactly the storm that takes the grid down.</div>';
      }

      /* Not pre-ticked. It was, and the button total did not include it, so the
         cart came to more than the button said — on a page whose whole argument
         is that we are the honest place to buy this. Opt in, and the total
         follows the box. */
      if (pick.care) {
        h += '<label class="ef-res__care"><input type="checkbox" data-ef-care> Add ' +
             pick.care.n + ' <span class="ef-res__care-rm">' + money(pick.care.rm) + '</span></label>';
      }
      h += '<button type="button" class="ef-btn ef-btn--primary ef-res__cta" data-ef-add' +
           ' data-analytics-title="Sizing add to cart" data-analytics-region="help-me-choose">' +
           CFG.cartText + ' &middot; ' + money(cfg.total) + '</button>';

      if (cfg.idx > 0) {
        var d = UNITS[cfg.idx - 1], reason;
        if (d.ac < c.cont) reason = 'its ' + num(d.ac) + ' W inverter cannot carry ' + num(c.cont) + ' W';
        else if (d.surge < c.surge) reason = 'its ' + num(d.surge) + ' W surge rating trips on the ' + num(c.surge) + ' W startup peak';
        else reason = 'reaching this runtime on it costs more than the ' + pick.n + ' does';
        h += '<div class="ef-res__alt"><b>' + d.n + '</b> (' + money(d.rm) + ') is one step down — ' + reason + '.</div>';
      }

      reveal(out, true);
      out.innerHTML = h;

      var addBtn = out.querySelector('[data-ef-add]');
      var careBox = out.querySelector('[data-ef-care]');
      if (careBox && addBtn) {
        careBox.addEventListener('change', function () {
          var t = cfg.total + (careBox.checked && pick.care ? pick.care.rm : 0);
          addBtn.innerHTML = CFG.cartText + ' &middot; ' + money(t);
        });
      }
      if (addBtn) {
        addBtn.addEventListener('click', function () {
          var items = [{ id: pick.vid, quantity: 1 }];
          if (bats && pick.xb && pick.xb.vid) items.push({ id: pick.xb.vid, quantity: bats });
          var care = out.querySelector('[data-ef-care]');
          if (care && care.checked && pick.care && pick.care.vid) items.push({ id: pick.care.vid, quantity: 1 });
          var label = addBtn.innerHTML;
          addBtn.disabled = true;
          addBtn.textContent = 'Adding…';
          window.efAddToCart(items)
            .then(function () { addBtn.disabled = false; addBtn.innerHTML = label; })
            .catch(function () { addBtn.disabled = false; addBtn.innerHTML = label; });
        });
      }
    }

    /* ---- controls ---- */
    root.querySelectorAll('.ef-calc__scen-btn').forEach(function (b) {
      b.addEventListener('click', function () {
        root.querySelectorAll('.ef-calc__scen-btn').forEach(function (o) {
          o.setAttribute('aria-pressed', o === b ? 'true' : 'false');
        });
        var s = SCEN[b.dataset.scen];
        sel = {};
        Object.keys(s.b).forEach(function (k) { sel[k] = s.b[k]; });
        hours = s.h;
        hrsEl.value = hours;
        hrsVal.textContent = hours + (hours === 1 ? ' hour' : ' hours');
        render();
      });
    });

    hrsEl.addEventListener('input', function () {
      hours = +hrsEl.value;
      hrsVal.textContent = hours + (hours === 1 ? ' hour' : ' hours');
      render();
    });

    /* boot from the data, never from the markup */
    var s0 = SCEN.blackout;
    Object.keys(s0.b).forEach(function (k) { sel[k] = s0.b[k]; });
    hours = s0.h;
    hrsEl.value = hours;
    hrsVal.textContent = hours + ' hours';
    render();
  }

  function init(scope) {
    (scope || document).querySelectorAll('.ef-calc[id^="backupcalc-"]').forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
